import { Numbers }			from "ts-base/numbers";
import { Comparator }		from "ts-base/comparator";

import { Textual }			from "@v3/data/textual";

import { IsoTimestampF }	from "@v3/data/time/isoTimestampF";
import { IsoDateTimeS }		from "@v3/data/time/isoDateTimeS";
import { IsoDate }			from "@v3/data/time/isoDate";
import { IsoTimeM }			from "@v3/data/time/isoTimeM";

// YYYY-MM-DD'T'hh:mm
export type IsoDateTimeM	= Textual.Value<typeof Base>;

// as used by datetime-local input fields
const Base	=
	Textual.regex(
		"IsoDateTimeM",
		// TODO time allows day 29-31 in too many months
		/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T([0-1][0-9]|2[0-3]):[0-5][0-9]$/,
		"must be an iso-8601 datetime in YYYY-MM-DD'T'hh:mm format"
	);

namespace Extension {
	export const fromIsoDateAndTime	= (date:IsoDate, time:IsoTimeM):IsoDateTimeM	=>
		Base.brand(`${date}T${time}`);

	export const toIsoDateAndTime	= (it:IsoDateTimeM):[ IsoDate, IsoTimeM ]	=> [
		getIsoDate(it),
		getIsoTimeM(it),
	];

	export const getIsoDate	= (it:IsoDateTimeM):IsoDate	=>
		IsoDate.brand(it.slice(0, 10));

	export const getIsoTimeM	= (it:IsoDateTimeM):IsoTimeM	=>
		IsoTimeM.brand(it.slice(11));

	//-----------------------------------------------------------------------------

	export const padToIsoDateTimeS	= (it:IsoDateTimeM):IsoDateTimeS	=>
		IsoDateTimeS.brand(`${it}:00`);

	//-----------------------------------------------------------------------------

	export const padToIsoTimestampF	= (it:IsoDateTimeM):IsoTimestampF	=>
		IsoTimestampF.brand(`${it}:00.000Z`);

	//-----------------------------------------------------------------------------

	// NOTE converting from Date to IsoDateTime reduces precision from millisecond to minute

	export const localFromDate	= (date:Date):IsoDateTimeM	=>
		IsoDateTimeM.brand(
			[
				Numbers.intDigits(date.getFullYear(),	4),
				"-",
				Numbers.intDigits(date.getMonth() + 1,	2),
				"-",
				Numbers.intDigits(date.getDate(),		2),
				"T",
				Numbers.intDigits(date.getHours(),		2),
				":",
				Numbers.intDigits(date.getMinutes(),	2),
			].join("")
		);

	export const localToDate	= (it:IsoDateTimeM):Date	=>
		new Date(
			parseInt(it.substring( 0, 4)),
			parseInt(it.substring( 5, 7)) - 1,
			parseInt(it.substring( 8, 10)),
			parseInt(it.substring(11, 13)),
			parseInt(it.substring(14, 16)),
		);

	//-----------------------------------------------------------------------------

	export const compare	= Comparator.builtinOf<IsoDateTimeM>();
}

export const IsoDateTimeM	= { ...Extension, ...Base };
